import { FadeIn, FadeInStagger } from "~/components/fade-in";

export function StatList({
  children,
  ...props
}: Omit<React.ComponentPropsWithoutRef<typeof FadeInStagger>, "children"> & {
  children: React.ReactNode;
}) {
  return (
    <FadeInStagger {...props}>
      <dl className="grid grid-cols-1 gap-8 sm:grid-cols-3">{children}</dl>
    </FadeInStagger>
  );
}

export function StatListItem({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <FadeIn className="flex flex-col-reverse">
      <dt className="label mt-2 text-ink-400">{label}</dt>
      <dd className="font-display text-4xl font-semibold tracking-tight text-ink-50 [font-variant-numeric:tabular-nums] sm:text-5xl">
        {value}
      </dd>
    </FadeIn>
  );
}
